import React from "react";
import { Box, Typography } from "@mui/material";

interface LayerPanelSectionProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Titled group of actions within a `LayerPanel`.
 */
const LayerPanelSection: React.FC<LayerPanelSectionProps> = ({ title, children }) => (
  <Box mb={1}>
    <Typography fontWeight="500">{title}</Typography>
    {children}
  </Box>
);

export default LayerPanelSection;
